module.exports = __webpack_public_path__ + "img/user.b48fa0a4.png";